// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IDEC4FL9t8gI5YjFVypC{flex-direction:column;display:flex}.sW3jNM51wfIYuzlxsO_Z{min-height:32px;color:var(--content-primary-tertiary);border:1px solid var(--border-neutral-default);border-radius:6px;flex-direction:row;justify-content:space-between;align-items:center;gap:4px;padding:8px;display:flex}.An_QHS1SYe8HQoeNtu1w{align-items:center;gap:2px;display:flex}.fUpbwSWfVa4cceUwRDy4{background:var(--yellow-20);color:var(--yellow-100);border:1px solid var(--black-10);border-radius:4px;margin-left:4px;padding:2px 4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IDEC4FL9t8gI5YjFVypC`,
	"section": `sW3jNM51wfIYuzlxsO_Z`,
	"qualityLabelContainer": `An_QHS1SYe8HQoeNtu1w`,
	"qualityBadge": `fUpbwSWfVa4cceUwRDy4`
};
export default ___CSS_LOADER_EXPORT___;
